export class CloningOptions {
  public testRequirements: boolean;
  public sampleInformation: boolean;
  public reasonForSubmittal: string;
}
